import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Slice = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 80;
`;

export const Container = styled.div`
  width: 25px;
  height: 25px;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 25px;
  height: 25px;
  svg {
    margin-left: 10px;
  }
  ${({ isOpen }) =>
    isOpen &&
    css`
      svg {
        fill: ${Palette.PrimaryGray._500};
      }
    `}
`;

/////////edit menu
export const MenuContainer = styled.div`
  position: relative;
  top: 0px;
  left: 0px;
  filter: drop-shadow(0px 0px 18px rgba(23, 43, 77, 0.08))
    drop-shadow(0px 8px 24px rgba(23, 43, 77, 0.08));
  background: #fff;
  border-radius: 8px;
`;

export const EditBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 16px;
  width: 410px;
`;

export const Header = styled.div``;

export const EditContent = styled.div`
  background: #fff;
  width: 100%;
  display: flex;
  align-items: flex-start;
`;

export const BtnWrap = styled.div`
  margin-top: 8px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 16px;
`;

export const ParentContainer = styled.div`
  z-index: 1000;
  position: absolute;
`;
